import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Materials_ds_get_material_inventory_measurements_by_unitIdService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { unitId: number }): 
  Promise<{ result: { Id?: number, ShortName?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.unitId)) {
      missingRequiredInParams.push('\'unitId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Materials/datasources/ds_get_material_inventory_measurements_by_unitId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { unitId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ShortName?: string }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.unitId)) {
      missingRequiredInParams.push('\'unitId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Materials/datasources/ds_get_material_inventory_measurements_by_unitId/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { unitId: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ShortName?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.unitId)) {
      missingRequiredInParams.push('\'unitId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Materials/datasources/ds_get_material_inventory_measurements_by_unitId/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
